import React, { useEffect, useState } from "react";
import Header from "./Header";
import SidenavBar from "./SidenavBar";
import Footer from "./Footer";
import style from "./navigation.module.sass";
// import FormNavigaion from '../formNavigation';
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../stateManager/store";
import AppsnavBar from "./AppsnavBar";
import { onSetBgdMenuVisibility, onSetBorderVisibility, onsetClrPicContext, onsetDropShadowVisibility, onSetFontStylesVisibility,  onSetTextEditorVisibility, onSetErrorFontStylesVisibility } from '../../stateManager/store/common/action';

const Navigation: React.FC = (props) => {
  const appType = useSelector((state: AppState) => state.apps.selectedApp.type);
  const {info: onboardingInfo } = useSelector((state:AppState)=> state.onboarding)
  const pathname = useLocation().pathname;
  const locationSplit = pathname.split("/");
  const location = locationSplit[1];
  const { colorPickerContext,dropShadowVisibility, backgroundMenuVisibility, fontStylesVisibility,textEditorVisibility,borderVisibility,errorFontStylesVisibility } = useSelector((state: any) => state.common);
  const isFormBuilder =
    locationSplit[5] === "forms" && pathname.endsWith("create");
  const isNewFormBuilder = locationSplit[5] === "forms" && pathname.endsWith("createv2")
  const isSoloFormBuilder = isFormBuilder && (appType === "a8solo" || appType === "a8chat");
  const isAssistedJourney = (appType !== "a8solo" && appType !== "a8chat") && pathname.endsWith("create") && locationSplit[4] === "journey";
  const isDmnBuilder =
    locationSplit[5] === "dmn" && pathname.endsWith("create");
  const dispatch = useDispatch()
  const isHome = pathname === "/home" || pathname === "/select-onboarding"

  const history = useHistory();

  const tabList = [
    "forms",
    "service",
    "functions",
    "data",
    "assist",
    "dmn",
    "solo",
    "data",
    "configuration",
    "acl",
    "deploy",
    "static-asset",
    "i18n",
    "dataModel",
    "ai-agents",
    "security"
  ];

  const tabIgnoreList = [
    "css",
    "images",
    "fonts",
    "json",
  ];
  const [isFunctionCreation, setIsFunctionCreation] = useState(false);
  const hideHeader =
    locationSplit[3] === "createFunction" ||
    locationSplit.includes('select-onboarding') ||
    locationSplit[3] === "edit" ||
    isSoloFormBuilder || isNewFormBuilder;

  const hideSideNav =  locationSplit.includes('select-onboarding');
  const aiAgents = locationSplit[5] === "ai-agents" && (locationSplit[7] === "workFlowAgents" && locationSplit[8] === "edit") || (locationSplit[6] === "workFlowAgents" && locationSplit[7] === "create")
  const isQNADialogRoute = locationSplit.length && ((locationSplit[5] === "events" && locationSplit[7] === "create") || (locationSplit[5] === "events" && locationSplit[8] === "edit") || (locationSplit[5] === "qna" && locationSplit[8] === "edit"))
  // set overflow to hidden for form designer route
  const contentStyle: React.CSSProperties = {
    overflowY: isFormBuilder ? "hidden" : "auto",
    top: isFunctionCreation ? 0 : 50,
    height: isFunctionCreation ? "100vh" : "calc(100vh - 50px)",
    left: tabList.includes(locationSplit[5]) && !tabIgnoreList.includes(locationSplit[6]) && locationSplit[8] != "create" && locationSplit[8] != "createv2" && !aiAgents ? "255px" : "60px",
    width: tabList.includes(locationSplit[5]) && !tabIgnoreList.includes(locationSplit[6]) && locationSplit[8] != "create" && locationSplit[8] != "createv2" && !aiAgents ? "calc(100vw - 260px)" : "calc(100vw - 60px)"
  };

  if(isQNADialogRoute) {
    contentStyle.zIndex = 4
  }

  const sideNavStyle: React.CSSProperties = {
    height: (isSoloFormBuilder || isNewFormBuilder || isFunctionCreation || isAssistedJourney || isHome ) ? "100vh" :"100vh",
    borderRight: "1px solid #E0E1E6"
  };

  // For solo form designer, header and footer will be hidden.
  // Therefore, we need to reset the follwing styles: `top` and `height`.
  if (isSoloFormBuilder || isNewFormBuilder  || isHome) {
    contentStyle.top = isDmnBuilder ? 50 : 0;
    contentStyle.height = "100vh";
  }
  const showFooter = (!isSoloFormBuilder ? !isDmnBuilder ? true : false : true)
  const closeModals = () => {
    if (colorPickerContext?.visibility) {
      dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))
    }
    if (dropShadowVisibility) {
      dispatch(onsetDropShadowVisibility(false))
    }
   if(dropShadowVisibility) {
    dispatch(onsetDropShadowVisibility(false))
   }
   if (backgroundMenuVisibility) {
    dispatch(onSetBgdMenuVisibility(false))
   }
   if (borderVisibility) {
    dispatch(onSetBorderVisibility(false))
  }
  if (fontStylesVisibility) {
    dispatch(onSetFontStylesVisibility(false))
  }
  if(errorFontStylesVisibility){
    dispatch(onSetErrorFontStylesVisibility(false))
  }
  if (textEditorVisibility){
    dispatch(onSetTextEditorVisibility(false))
  }
  }
  useEffect(() => {
    if ((locationSplit[4] === "assist" && locationSplit[locationSplit.length - 1] === "create") && (locationSplit[5] === "functions" || locationSplit[5] === "service") || (locationSplit[4] === "solo" && locationSplit[locationSplit.length - 1] === "create") && (locationSplit[5] === "functions" || locationSplit[5] === "service")) {
      setIsFunctionCreation(true)
    } else {
      setIsFunctionCreation(false)
    }
  }, [pathname])

  return (
    <React.Fragment>
      {(!hideHeader && !isFunctionCreation) && (localStorage.getItem("studioToken") !== null) &&
        <div onClick={() => closeModals()} className={style.headerContainer}>
          <Header />
        </div>
      }
      {!hideSideNav && (localStorage.getItem("studioToken") !== null) &&
        <div onClick={() => closeModals()} className={style.sideNavContainer} style={sideNavStyle}>
          <SidenavBar />
          </div>
      }


      {tabList.includes(locationSplit[5]) && locationSplit[8] != "create" && locationSplit[8] != "createv2" && !tabIgnoreList.includes(locationSplit[6]) && !aiAgents &&(
        <div onClick={() => closeModals()} style={{ width: "195px", position: "absolute", left: 60, top: 50, borderRight: "1px solid rgba(149, 171, 211, 0.2)" }}>
          <AppsnavBar />
        </div>

      )}

      <div
        style={contentStyle}
        onClick={() => closeModals()}
        className={
          location !== "profile" ? style.children : style.profileChildren
        }
      >
        {props.children}
      </div>
    </React.Fragment>
  );
};

export default Navigation;
